module.exports = __webpack_public_path__ + "img/frame (101).5e972c17.jpg";